var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMolecularBiology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.741 -5.136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.425,90.9l-9.2,6.052h4.689L96.822,91.8l-.536-.6h0a2.206,2.206,0,0,0-2.9-.334Z",
    transform: "translate(10.23 5.547)",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.767,
    height: 14.206,
    transform: "translate(28.659 108.377)",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.773,91.557a2.177,2.177,0,0,0-2.9-.551l-14.021,9.144a1.677,1.677,0,0,1-.944.29H76.189a1.771,1.771,0,0,1-1.684-.958,1.949,1.949,0,0,1-.145-.711,1.755,1.755,0,0,1,1.755-1.741h9.942A3.1,3.1,0,0,0,88.8,93.937V91.673H68.162a10.69,10.69,0,0,0-5.936,1.8l-13.454,9h0a1.685,1.685,0,0,1-.972.3H42.08v13.57H61.921a16.971,16.971,0,0,0,4.2-.58l31-7.838a20.452,20.452,0,0,0,6.75-3.12l14.4-10.16a2.244,2.244,0,0,0,.9-1.452A2.211,2.211,0,0,0,118.773,91.557Z",
    transform: "translate(-1.156 5.601)",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.328,72.832a6.064,6.064,0,0,0-.395-2.176l5.948-3.593h0a7.7,7.7,0,0,0,12.6-1.069L75.14,68.6a4.669,4.669,0,0,0-.066.807,5.226,5.226,0,1,0,.892-2.908L69.3,63.882a7.464,7.464,0,0,0,.2-1.67,7.613,7.613,0,0,0-1.116-4l4.765-3.968A5.2,5.2,0,1,0,71.7,52.467l-4.765,3.967a7.657,7.657,0,0,0-5.122-1.96,7.752,7.752,0,0,0-1.754.207L56.81,46.463a6.2,6.2,0,1,0-3.293.938,6.282,6.282,0,0,0,1.182-.112l3.255,8.217a7.694,7.694,0,0,0-3.846,6.661,7.612,7.612,0,0,0,.6,2.964l-5.948,3.65a6.134,6.134,0,1,0,1.567,4.089Z",
    transform: "translate(10.824 7.627)",
    fill: "#02e2ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecularBiology);
export default __webpack_public_path__ + "static/media/molecular_biology.a63843d339425922aa4d708ba66cd37b.svg";
export { ForwardRef as ReactComponent };